import sanitizeHtml, { IOptions } from 'sanitize-html';

export function htmlSanitize(
  str: string | undefined | null,
  options: IOptions = {
    allowedTags: [
      ...sanitizeHtml.defaults.allowedTags,
      'img',
      'iframe',
      'style',
      'button',
      'details',
      'summary',
      'script',
      'input',
      'video',
      'svg',
      'path',
      'g',
      'circle',
      'rect',
      'line',
      'polyline',
      'polygon',
      'ellipse',
      'text',
      'linearGradient',
      'defs',
      'stop',
      'mask',
    ],
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      '*': ['style', 'class', 'id', 'type', 'checked', 'src', 'data-*'],
      svg: ['viewBox', 'xmlns', 'width', 'height', 'xmlns:xlink', 'aria-hidden', 'role'],
      path: [
        'd',
        'fill',
        'stroke',
        'stroke-width',
        'stroke-linecap',
        'stroke-linejoin',
        'transform',
      ],
      polygon: ['points', 'fill', 'stroke', 'stroke-width', 'transform'],
      polyline: ['points', 'fill', 'stroke', 'stroke-width', 'transform'],
      circle: ['cx', 'cy', 'r', 'fill', 'stroke', 'stroke-width', 'transform'],
      rect: [
        'x',
        'y',
        'width',
        'height',
        'rx',
        'ry',
        'fill',
        'stroke',
        'stroke-width',
        'transform',
      ],
      line: ['x1', 'y1', 'x2', 'y2', 'stroke', 'stroke-width', 'transform'],
      ellipse: ['cx', 'cy', 'rx', 'ry', 'fill', 'stroke', 'stroke-width', 'transform'],
      g: ['transform', 'fill', 'stroke'],
      text: ['x', 'y', 'dx', 'dy', 'text-anchor', 'fill', 'stroke', 'transform'],
      linearGradient: ['id', 'x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform'],
      stop: ['offset', 'stop-color', 'stop-opacity'],
      mask: ['id', 'x', 'y', 'width', 'height', 'maskUnits'],
      video: [
        ...(sanitizeHtml.defaults.allowedAttributes.video || []),
        'autoplay',
        'controls',
        'loop',
        'muted',
        'playsinline',
      ],
    },
    allowVulnerableTags: true,
    parser: {
      lowerCaseTags: false,
      lowerCaseAttributeNames: false,
    },
  },
): string {
  return str ? sanitizeHtml(str, { disallowedTagsMode: 'discard', ...options }) : '';
}
